import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	ActionSheetController,
	LoadingController,
	NavController,
	Platform
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import {
	EventDetailsModel,
	EventProvider,
	MyEventListModel
} from '../../providers/event/event';
import { LoaderProvider } from '../../providers/loader/loader';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { Router } from '@angular/router';
import { TapticEngine } from '@awesome-cordova-plugins/taptic-engine/ngx';
import { NavigationService } from 'src/providers/navigation/navigation.service';

/**
 * Generated class for the MyEventListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
	selector: 'my-event-list-item',
	templateUrl: 'my-event-list-item.html',
	styleUrls:['./my-event-list-item.scss']
})
export class MyEventListItemComponent {
	@Input('event')
	event: MyEventListModel;
	@Output()
	removed: EventEmitter<number>;
	previousUrl:string;

	validDate: Date;
	constructor(
		public eventService: EventProvider,
		private actionSCtrl: ActionSheetController,
		private loadingCtrl: LoadingController,
		public appDetector: AppDetectorProvider,
		private router:Router,
		public translate: TranslateService,
		private taptic: TapticEngine,
		private platform: Platform,
		private navCtrl: NavController,
		private navService:NavigationService
	) {
		this.removed = new EventEmitter<number>();
		this.previousUrl = this.navService.getPreviousUrl();

	}

	ngOnChanges() {
		let splited: number[] = [];
		if(this.event.dateFormatted){
			this.event.dateFormatted.split('.').forEach(item => {
				splited.push(parseInt(item));
			});
			this.validDate = new Date(splited[2], splited[1], splited[0]);
		}
		if(this.event.date){
			this.validDate = new Date(this.event.date);
		}
	}

	removeEvent() {
		this.eventService.removeMyEvent(this.event.id).then((succ: boolean) => {
			if (succ) {
				this.removed.emit(this.event.id);
			}
		});
	}

	async openEventDetails() {
		let loader = await this.loadingCtrl.create({
			message: this.translate.instant('GLOBAL_LOADING')
		});
		loader.present();
		let prevTab = this.previousUrl ?this.previousUrl.split('/')[1]:this.previousUrl='/tab1/'
        console.log('prevTab ', prevTab )
		if(prevTab!=='/tab1' && prevTab!=='/tab2'){
			prevTab = '/tab2'
		}

		this.eventService
			.getEventDetails(this.event.id)
			.then((event: EventDetailsModel) => {
				this.navCtrl.navigateForward(`${prevTab}/event/details/tabs`, {state:{event}})
				.then(()=>{
					loader.dismiss();
				})
				// this.navCtrl.push(EventTabsPage, { event: event })
				
			});
	}

	async showSheet() {
		let sheet = await this.actionSCtrl.create({
			header: this.translate.instant('GLOBAL_OPTIONS'),
			buttons: [
				{
					text: this.translate.instant('GLOBAL_DELETE'),
					role: 'destructive',
					handler: () => {
						this.removeEvent();
					}
				},
				{
					text: this.translate.instant('GLOBAL_CANCEL'),
					role: 'cancel'
				}
			]
		});
		if (window['TapticEngine'] && this.platform.is('ios')) {
			this.taptic.selection();
		}
		sheet.present();
	}

	onDelete(ev) {
		this.eventService.removeFavEvent(ev, ev.id).then(() => {
			this.updateEventList(ev.id);
		})
	}

	updateEventList(id) {
		this.removed.emit(id);
	}
}
